import { useState, useEffect, useRef, createContext, useContext } from "react";

const InactivityContext = createContext();

export const InactivityMonitor = ({
  inactivityTime = 30000,
  checkInterval = 5000,
  children,
}) => {
  const [isInactive, setIsInactive] = useState(false);
  const lastActivityRef = useRef(Date.now());

  const resetTimer = () => {
    lastActivityRef.current = Date.now();
    if (isInactive) setIsInactive(false);
  };

  useEffect(() => {
    const handleClick = () => {
      window.dataLayer.push({
        event: "gtm.click",
        hostname: window.location.origin,
        userStatus:
          localStorage.getItem("userToken") !== null ? "existing" : "guest",
      });
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);

    const intervalId = setInterval(() => {
      const timeSinceLastActivity = Date.now() - lastActivityRef.current;

      if (timeSinceLastActivity > inactivityTime) {
        setIsInactive(true);
      }
    }, checkInterval);

    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      clearInterval(intervalId);
    };
  }, [isInactive, inactivityTime, checkInterval]);

  return (
    <InactivityContext.Provider value={isInactive}>
      {children}
    </InactivityContext.Provider>
  );
};

export const useInactivity = () => {
  return useContext(InactivityContext);
};
